module.exports = __webpack_public_path__ + "img/1-pour-la-planete.d6a9dde3.svg";